import React from 'react';
import { Blocks } from 'react-loader-spinner';
import './TopLoadingBar.css';

const TopLoadingBar = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="blocks-loader-overlay">
      <Blocks
        height="80"
        width="80"
        // Remove color prop entirely
        ariaLabel="blocks-loading"
        wrapperStyle={{}}
        wrapperClass="blocks-wrapper"
        visible={true}
      />
    </div>
  );
};

export default TopLoadingBar;